import types from '../types';

/**
 * @param {types.Option[]} options
 * @param {string} id
 * @returns {types.Option[]}
 */
const getCheckboxGroupNextState = (options, id) => {
    if (!options || !Array.isArray(options) || !options.length) {
        throw new Error('Options are missing!');
    }

    return options.map(option => {
        let { checked } = option;
        const isOptionChanged = option.id === id;

        /* toggle state */
        if (isOptionChanged) {
            checked = !checked;
        }

        let nextOption = {
            ...option,
            checked
        };

        const { subOptions } = option;

        if (subOptions && subOptions.length) {
            let nextSubOptions = isOptionChanged
                ? subOptions.map(subOption => {return {
                    ...subOption,
                    checked: !!checked
                }})
                : subOptions.map(subOption => {
                    let subOptionChecked = subOption.checked;
                    /* toggle state */
                    if (subOption.id === id) {
                        subOptionChecked = !subOptionChecked;
                    }

                    return {
                        ...subOption,
                        checked: subOptionChecked
                    };
                });

            const subOptionsGroupIsChecked = nextSubOptions.every(
                subOption => subOption.checked
            );

            checked = !!subOptionsGroupIsChecked;

            nextOption = {
                ...option,
                checked,
                subOptions: nextSubOptions
            };
        }

        return nextOption;
    });
};

export default getCheckboxGroupNextState;
